/* Import Modules */
import axios, { AxiosRequestConfig } from "axios";
import { rentalContractEditForm } from "../../variables";
import toastr from "toastr";
import { ref } from "vue";

/* Define Variables. */
const getScheduleId = () => {
  return rentalContractEditForm.scheduleId;
};

const getAxiosOptions = () => {
  const axiosOptions: AxiosRequestConfig = {
    url: `/api/line_copy/${getScheduleId()}`,
    method: "GET",
    data: {},
  };

  return axiosOptions;
};

export const getLineCopy = async () => {
  const axiosOptions = await getAxiosOptions();
  const lineCopyValue = ref<any>(null);
  await axios(axiosOptions)
    .then((result) => {
      lineCopyValue.value = result.data;
    })
    .catch((error) => {
      toastr.error("予期せぬエラーが発生しました");
      lineCopyValue.value = null;
      console.log(error);
    });
  return lineCopyValue.value;
};
